import axios from 'axios';
import { backendHOST } from '../client-config/client-config';
import setAuthToken from '../utils/setAuthToken';

const mailUrl = `${backendHOST}/api/mail`;

function ensureAuthToken() {
  if (localStorage.token) {
    setAuthToken(localStorage.token);
    return true;
  }

  return false;
}

const jsonConfig = {
  headers: {
    'Content-Type': 'application/json',
  },
};

export async function getCampaigns({ onlyNotSent = 1 } = {}) {
  if (!ensureAuthToken()) {
    return [];
  }

  try {
    const res = await axios.get(`${mailUrl}/Campaign`, {
      params: {
        onlyNotSent,
      },
    });

    return Array.isArray(res.data) ? res.data : [];
  } catch (e) {
    console.error('getCampaigns error', e);
    return [];
  }
}

export async function createCampaign(campaign) {
  if (!ensureAuthToken()) {
    return { isOk: false };
  }

  try {
    const res = await axios.post(`${mailUrl}/Campaign`, campaign, jsonConfig);

    return res.data;
  } catch (e) {
    console.error('createCampaign error', e);
    return { isOk: false };
  }
}

export async function updateCampaign(id, campaign) {
  if (!ensureAuthToken()) {
    return { isOk: false };
  }

  try {
    const res = await axios.put(
      `${mailUrl}/Campaign/${id}`,
      campaign,
      jsonConfig,
    );

    return res.data;
  } catch (e) {
    console.error('updateCampaign error', e);
    return { isOk: false };
  }
}

export async function deleteCampaign(id) {
  if (!ensureAuthToken()) {
    return { isOk: false };
  }

  try {
    const res = await axios.delete(`${mailUrl}/Campaign/${id}`);

    return res.data;
  } catch (e) {
    console.error('deleteCampaign error', e);
    return { isOk: false };
  }
}

export async function getCampaignDetails(campaignId) {
  if (!ensureAuthToken()) {
    return [];
  }

  try {
    const res = await axios.get(`${mailUrl}/CampaignDetails`, {
      params: {
        campaignId,
      },
    });

    return Array.isArray(res.data) ? res.data : [];
  } catch (e) {
    console.error('getCampaignDetails error', e);
    return [];
  }
}

export async function deleteCampaignDetail(id) {
  if (!ensureAuthToken()) {
    return { isOk: false };
  }

  try {
    const res = await axios.delete(`${mailUrl}/CampaignDetails/${id}`);

    return res.data;
  } catch (e) {
    console.error('deleteCampaignDetail error', e);
    return { isOk: false };
  }
}

export async function getCampaignUsers({ campaignId, allUsers = false }) {
  if (!ensureAuthToken()) {
    return [];
  }

  try {
    const res = await axios.get(`${backendHOST}/api/auth/user`, {
      params: {
        forMailCampaign: 1,
        allUsers,
        campaignId,
      },
    });

    return Array.isArray(res.data) ? res.data : [];
  } catch (e) {
    console.error('getCampaignUsers error', e);
    return [];
  }
}

export async function createCampaignDetails(campaignKey, userId) {
  if (!ensureAuthToken()) {
    return {
      isOk: false,
    };
  }

  try {
    const res = await axios.post(
      `${mailUrl}/CampaignDetails`,
      {
        campaignId: campaignKey,
        mailStatus: 10,
        mailToUser: userId,
      },
      jsonConfig,
    );

    if (res.status === 200 || res.status === 201) {
      return res.data;
    }

    return {
      isOk: false,
    };
  } catch (e) {
    console.error('createCampaignDetails error', e);

    return {
      isOk: false,
    };
  }
}
